import { render, staticRenderFns } from "./PHI.vue?vue&type=template&id=3b42bc6d&scoped=true&"
import script from "./PHI.vue?vue&type=script&lang=js&"
export * from "./PHI.vue?vue&type=script&lang=js&"
import style0 from "./PHI.vue?vue&type=style&index=0&id=3b42bc6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b42bc6d",
  null
  
)

export default component.exports